<section class="mat-typography">
    <h1> {{ data == null ? "Proceed?" : data.Heading }} </h1>
</section>
<div>
    <p>
        {{ data == null ? "" : data.Message }}
    </p>
</div>
<div class="saveButtons">
    <button mat-raised-button type="submit" (click)="closeDialog(true)"><i class="material-icons">{{ data != null && data["SuccessAction"] != null ? data["SuccessAction"]["Icon"] : "add" }}</i> {{ data != null && data["SuccessAction"] != null ? data["SuccessAction"]["Name"] : "Confirm" }}</button>
    <button class="pull-right" mat-raised-button type="submit" (click)="closeDialog(false)"><i class="material-icons">{{ data != null && data["CancelAction"] != null ? data["CancelAction"]["Icon"] : "cancel" }}</i> {{ data != null && data["CancelAction"] != null ? data["CancelAction"]["Name"] : "Cancel" }}</button>
</div>